<template>
  <div id="applications-view">
    <h1>Postulations
      <v-btn round color="primary" @click="exportApplications">Exporter en CSV</v-btn>
    </h1>
    <div>
      <applicationsFilters />
      <v-card-title v-if="hasSelected && $store.getters['moduleUser/userIsResponsible']">
        <div>
          Modifications groupées
          <v-select
            :items="$store.state.moduleApplications.available_status"
            label="Statut"
            item-text="status_value"
            item-value="status_value"
            v-model="multipleEditor.status"
          ></v-select>
          <v-btn round color="primary" @click="updateMultiple">Appliquer</v-btn>
          <v-btn round color="primary" @click="deleteMultiple">Supprimer</v-btn>
          <v-btn round color="primary" @click="toggleMailDialog">Contacter</v-btn>
        </div>
      </v-card-title>
      <v-data-table
        v-model="selected"
        :headers="headers"
        :items="$store.getters['moduleApplications/getFilteredApplications']"
        item-key="applicant_id"
        :pagination.sync="pagination"
        :select-all="$store.getters['moduleUser/userIsResponsible']"
        :search="$store.state.moduleApplications.filters.search"
        :custom-sort="customSort"
      >
        <template v-slot:items="props">
          <span></span>
          <tr
        @click="handleClick(props.item.applicant_id, $event)"
        @dblclick="handleDoubleClick(props.item.applicant_id)"
        @contextmenu.prevent="handleContextMenu(props.item.applicant_id, $event)"
        :class="{ isNew: isNew(props.item.fk_status, props.item.applicant_application_date) && !$store.getters['moduleUser/userIsResponsible'] }"
      >
            <td v-if="$store.getters['moduleUser/userIsResponsible']">
              <v-checkbox v-model="props.selected" hide-details color="primary"></v-checkbox>
            </td>
            <td>
              <router-link :to="{ name: 'application', params: { id: props.item.applicant_id } }" v-on="on">
                <v-icon big>pageview</v-icon>
              </router-link>
            </td>
            <td>{{ props.item.applicant_name }} {{ props.item.applicant_fsname }}</td>
            <td>{{ props.item.job_full_value }}</td>
            <td>{{ props.item.location_site }}</td>
            <td>
              <span v-if="props.item.applicant_maturity">&#10004;</span>
              <span v-else>&#10008;</span>
            </td>
            <td>{{ props.item.applicant_address_street }} {{ props.item.applicant_address_npa }}</td>
            <td>{{ props.item.applicant_mail }}</td>
            <td>
              {{ props.item.applicant_birthdate }}
            </td>
            <td>
              <span
                v-if="props.item.applicant_has_majority"
              >&#10004;</span>
              <span v-else>&#10008;</span>
            </td>
            <td>{{ props.item.applicant_nationality }}</td>
            <td>{{ props.item.applicant_origin }}</td>
            <td>
              <img
                src="@/assets/french_logo.png"
                alt="logo_french"
                width="18"
                v-if="props.item.applicant_speaks_french"
              />
              <img
                src="@/assets/german_logo.png"
                alt="logo_german"
                width="18"
                v-if="props.item.applicant_speaks_german"
              />
              <img
                src="@/assets/english_logo.png"
                alt="logo_english"
                width="18"
                v-if="props.item.applicant_speaks_english"
              />
              <img
                src="@/assets/others_logo.png"
                alt="logo_others"
                width="18"
                v-if="props.item.applicant_speaks_other"
              />
            </td>
            <td>{{ props.item.applicant_scolarity_end }}</td>
            <td>{{ getFormatedDate(props.item.applicant_application_date) }}</td>
            <td v-if="!$store.getters['moduleUser/userIsResponsible']">
              <span v-if="props.item.marker_value !== null" class="d-flex">
                {{ props.item.marker_value }}
                <v-icon inline small>star_rating</v-icon>
              </span>
              <span v-else>
                -
              </span>
            </td>
            <td v-if="$store.getters['moduleUser/userIsResponsible']">
              <v-select
                :items="$store.state.moduleApplications.available_status"
                item-text="status_value"
                item-value="status_value"
                v-model="props.item.fk_status"
                @change="updateStatus(props.item.applicant_id, props.item.fk_status)"
                v-if="$store.getters['moduleUser/userIsResponsible']"
              ></v-select>
              <span v-else>{{ props.item.fk_status }}</span>
            </td>
          </tr>
        </template>
      </v-data-table>
    </div>
    <MailDialog :opened="mail_dialog_opened" :to="selected" @closed="toggleMailDialog()"></MailDialog>
  </div>
</template>

<script>
import ApplicationsFilters from '@/components/applicationsFilters.vue'
import MailDialog from '@/components/application/mailDialog.vue'

export default {
  name: 'applications-view',
  data () {
    return {
      selected: [],
      multipleEditor: {
        status: ''
      },
      headers: [
        { text: 'Actions', value: 'actions', sortable: false },
        { text: 'Nom, Prénom', align: 'left', value: 'applicant_fsname' },
        { text: 'Formation', value: 'applicant_formation' },
        { text: 'Lieu', value: 'applicant_formation_location' },
        { text: 'Maturité', value: 'applicant_maturity' },
        { text: 'Adresse', value: 'applicant_npa' },
        { text: 'Email', value: 'applicant_mail' },
        { text: 'Date naissance', value: 'applicant_birthdate' },
        { text: 'Majeur', value: 'applicant_has_majority' },
        { text: 'Nationalité', value: 'applicant_nationality' },
        { text: 'Origine', value: 'applicant_origin' },
        { text: 'Langues', value: 'applicant_languages', sortable: false },
        { text: 'Fin de scolarité', value: 'applicant_scolarity_end' },
        { text: 'Date postulation', value: 'applicant_application_date' },
        ...(this.$store.getters['moduleUser/userIsResponsible']
        ? []
        : [{ text: 'Note', value: 'marker_value' }]
        ),
        ...(this.$store.getters['moduleUser/userIsResponsible']
        ? [{ text: 'Statut', value: 'fk_status' }]
        : []
        )
      ],
      pagination: { sortBy: 'applicant_application_date', descending: true, rowsPerPage: 25 },
      mail_dialog_opened: false
    }
  },
  created () {
    this.loadApplications()
  },
  computed: {
    hasSelected () { return this.selected.length > 0 }
  },
  methods: {
    loadApplications () {
      this.$store.dispatch('moduleApplications/getApplications')
      this.$store.dispatch('moduleApplications/getAvailableStatus')
      this.$store.dispatch('moduleUser/getUserPermittedJobs')
      this.$store.dispatch('moduleApplications/getEmailTemplates').then(templates => {
    this.mailTemplates = templates;
  });
    },
    navigateTo (id) {
      this.$router.push('/application/' + id)
    },
    updateStatus (id, status) {
      this.$store.dispatch('moduleApplications/changeApplicationStatus', { id: id, status: status })
    },
    updateMultiple () {
      this.selected.forEach(item => {
        this.updateStatus(item.applicant_id, this.multipleEditor.status)
      })
      setTimeout(() => {
        this.$store.dispatch('moduleApplications/getApplications')
      }, 300)
    },
    deleteOne (id) {
      this.$store.dispatch('moduleApplications/deleteApplication', { id: id })
    },
    deleteMultiple () {
      if (confirm('Voulez-vous vraiment supprimer les candidatures sélectionnées ? \n Cette action est irréversible.')) {
        this.selected.forEach(item => {
          this.deleteOne(item.applicant_id)
        })
      }
      setTimeout(() => { this.$store.dispatch('moduleApplications/getApplications') }, 300)
    },
    toggleMailDialog () {
      this.mail_dialog_opened = !this.mail_dialog_opened
    },
    isNew (status, date) {
      if (this.$store.getters['moduleUser/userIsResponsible']) {
        return status === 'Nouveau'
      } else {
        return date > this.$store.state.moduleUser.lastConnection.last_connection_date
      }
    },
    getFormatedDate(value) {
      const date = new Date(value);
      const formattedDate = `${date.getDate()}/${date.getMonth() + 1}/${date.getFullYear()} à ${('0' + date.getHours()).slice(-2)}:${('0' + date.getMinutes()).slice(-2)}`;
      return formattedDate;
    },
    customSort: function (items, column, descending) {

      const compareAlphabetically = (a, b) => {
        return a[column] > b[column] ? 1 : -1;
      };

      //Sort by date
      const compareByDate = (a, b) => {
        const dateify = (txt) => new Date(txt[column].split('/').reverse().join('-'))
        return dateify(a) - dateify(b);
      };

      const compareFunction = pickCompareFunction(column);

      function pickCompareFunction (column) {
        if (column === 'applicant_birthdate') return compareByDate;
        return compareAlphabetically;
      }

      const compareFunctionReversed = function(a, b) { return - compareFunction(a, b); };

      return [...items].sort(descending ? compareFunction : compareFunctionReversed);
    },
    exportApplications() {
      const currentDate = this.getFormattedDate(new Date());
      const filterInfo = this.getFilterInfo(); // Fonction à définir pour récupérer les informations du filtre
      const filterText = filterInfo ? `_${filterInfo}` : ''; // Ajoutez le filtre au nom du fichier si des informations sont disponibles
      const filename = `${currentDate}_CanAp_Export_${filterText}.csv`;
      const allApplications = this.$store.getters['moduleApplications/getFilteredApplications'];
      const applicationsData = allApplications.map(item => {
        return {
          'Lien': window.location.origin + '/gest/' + this.$router.resolve('application/' + item.applicant_id).href,
          'Nom': item.applicant_name || '',
          'Prénom': item.applicant_fsname || '',
          'Formation': item.job_full_value || '',
          'Lieu': item.location_site || '',
          'Maturité': item.applicant_maturity ? 'Oui' : 'Non',
          'Adresse': this.formatArray([item.applicant_address_street, item.applicant_address_npa]) || '',
          'Email': item.applicant_mail || '',
          'Date naissance': item.applicant_birthdate || '',
          'Majeur': item.applicant_has_majority ? 'Oui' : 'Non',
          'Nationalité': item.applicant_nationality || '',
          'Origine': item.applicant_origin || '',
          'Langues': this.generateLanguagesString(item),
          'Fin de scolarité': item.applicant_scolarity_end || '',
          'Date postulation': this.formatDate(item.applicant_application_date) || '',
        };
      });

      const csvContent = this.convertToCSV(applicationsData);
      const blob = new Blob([csvContent], { type: 'text/csv' });
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.download = filename;
      link.click();
    },
      getFormattedDate(date) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      const hours = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');
      const formattedDate = `${year}${month}${day}${hours}${minutes}`;
      return formattedDate;
    },
    getFilterInfo() {
      const filterProperty = this.$store.state.moduleApplications.filters.filterProperty;
      const searchFilter = this.$store.state.moduleApplications.filters.search;
      const selectedJobFilter = this.$store.state.moduleApplications.filters.selectedJob;
      const selectedFilter = searchFilter || selectedJobFilter;
      const sanitizedFilter = selectedFilter ? selectedFilter.replace(/\s/g, '_') : '';
      const filterInfo = sanitizedFilter;

      return filterInfo;
    },

    formatArray(value) {
      return Array.isArray(value) && value.length > 0 ? value.join(', ') : value || '';
    },

    formatDate(date) {
      return date ? new Date(date).toLocaleString('fr-CH') : '';
    },
    generateLanguagesString(item) {
    const languageMappings = [
      { key: 'applicant_speaks_french', value: 'FR' },
      { key: 'applicant_speaks_english', value: 'EN' },
      { key: 'applicant_speaks_german', value: 'DE' },
      { key: 'applicant_speaks_other', value: 'Autre' },
    ];
    return languageMappings
      .filter(mapping => item[mapping.key])
      .map(mapping => mapping.value)
      .join(', ');
    },

    convertToCSV(data) {
    const header = Object.keys(data[0]).join(',') + '\n';
    const rows = data.map(row => Object.values(row).map(col => '"' + col + '"').join(',') + '\n');
    return header + rows.join('');
    },
  },
  consultApplication(id, event) {
    if (event.ctrlKey || event.button === 1) {
      const newTab = window.open('/gest/#/application/' + id, '_blank');
      if (newTab) {
        newTab.focus();
      }
      event.preventDefault();
    } else {
      this.$router.push('/application/' + id);
    }},
  handleClick(id, event) {
    const route = { name: 'application', params: { id: id } };
    
    // Check for middle click
    if (event.button === 1) {
      const newTab = window.open(this.$router.resolve(route).href, '_blank');
      if (newTab) {
        newTab.focus();
      }
      event.preventDefault();
    }
  },
  handleDoubleClick(id) {
    const route = { name: 'application', params: { id: id } };
    const newTab = window.open(this.$router.resolve(route).href, '_blank');
    if (newTab) {
      newTab.focus();
    }
  },
  handleContextMenu(id, event) {
    event.preventDefault();
  },
  components: {
    ApplicationsFilters,
    MailDialog
  }
}
</script>

<style scoped>
.isNew {
  border-left: 5px solid red;
}
</style>
